// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-sizes table{border-collapse:collapse;width:100%}.page-sizes table tr{background:#d9d9d9}.page-sizes table tr:nth-child(2n){background:transparent}.page-sizes table td{border:1px solid #aaa;padding:20px 7px;text-align:center}.page-sizes table td:first-child{font-weight:700;text-align:left;width:40%}@media (max-width:1023px){.page-sizes table td{font-size:12px;padding:1px}}.page-sizes__table-title{font-size:17px;text-align:center!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
